// extracted by mini-css-extract-plugin
export default {"vendor":"VendorIcons_vendor__DzKCZ","list":"VendorIcons_list__09Ahi","item":"VendorIcons_item__XvEN6","preferred":"VendorIcons_preferred__8yiQN"};